"use client";

import React from "react";
import { Check, Cpu } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
const plans = [{
  id: "tarif-layanan",
  name: "Struktur Tarif Dasar",
  description: "Rincian biaya jasa layanan transportasi dan pengantaran terbaru.",
  processor: "Update Tarif 2024",
  price: "Mulai Rp 10.000",
  features: ["Layanan Delivery: Rp 12.000/km", "Layanan Ride: Rp 10.000/km", "Layanan Food: Rp 11.000/km", "Biaya Jasa Aplikasi Flat", "Asuransi Perjalanan Termasuk"],
  buttonText: "Cek Detail Tarif",
  buttonLink: "/AccountPage"
}, {
  id: "bonus-insentif",
  name: "Program Bonus Driver",
  description: "Skema insentif dan bonus tambahan untuk mitra pengemudi aktif.",
  processor: "Skema Bonus Harian",
  price: "Hingga Rp 150.000",
  features: ["Bonus Target Harian Cair Cepat", "Insentif Jam Sibuk (Peak Hour)", "Bonus Loyalitas Mingguan", "Potongan Komisi Lebih Rendah", "Program Beasiswa Anak Mitra"],
  buttonText: "Daftar Jadi Mitra",
  buttonLink: "/CooperationPage"
}];
export default function TarifBonus() {
  return <section data-section-id="261853" id="tarif-bonus" className="bg-background py-40 text-foreground">
      <div className="container mx-auto px-4">
        <div className="mx-auto max-w-5xl">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
            {plans.map((plan, i) => <Card key={plan.id} data-index={i} className="flex flex-col overflow-hidden rounded-lg border-border bg-card shadow-md transition-transform duration-500 ease-[cubic-bezier(0.25,1,0.5,1)] hover:scale-105">
                <CardHeader className="pb-4 pt-8 px-8 border-t-4 border-t-primary">
                  <Badge variant="outline" className="mb-6 w-fit border-primary/30 text-primary px-3 py-1 rounded-md">
                    <Cpu className="mr-2 h-4 w-4" />
                    {plan.processor}
                  </Badge>
                  <CardTitle className="font-default text-3xl text-card-foreground">
                    {plan.name}
                  </CardTitle>
                  <CardDescription className="mt-3 text-base text-muted-foreground font-default">
                    {plan.description}
                  </CardDescription>
                  <div className="mt-8">
                    <span className="font-default text-2xl font-bold text-primary">
                      {plan.price}
                    </span>
                  </div>
                </CardHeader>

                <div className="px-8">
                  <Separator className="bg-muted" />
                </div>

                <CardContent className="flex-grow px-8 py-8">
                  <ul className="space-y-4">
                    {plan.features.map((feature, index) => <li key={index} data-index={index} className="flex items-start gap-3 font-default text-muted-foreground">
                        <Check className="mt-0.5 h-5 w-5 shrink-0 text-primary" />
                        <span className="text-sm md:text-base">{feature}</span>
                      </li>)}
                  </ul>
                </CardContent>

                <CardFooter className="px-8 pb-8 pt-0">
                  <Button variant="secondary" size="lg" className="h-14 w-full rounded-md text-base font-semibold shadow-sm bg-secondary text-secondary-foreground hover:bg-secondary/90" asChild>
                    <Link to={plan.buttonLink}>{plan.buttonText}</Link>
                  </Button>
                </CardFooter>
              </Card>)}
          </div>
        </div>
      </div>
    </section>;
}